import type { ToggleButtonOption } from 'common/components/Elements/ToggleButton/ToggleButton';
import ToggleButton from 'common/components/Elements/ToggleButton/ToggleButton';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React from 'react';

export interface ComponentProps {
  command: EnhancedCommand;
}

function CommandToggleButton({ command }: ComponentProps) {
  const {
    active, onClick, commands, toggleButton,
  } = command;

  const options: ToggleButtonOption<string>[] = commands.map((c) => ({
    id: c.id,
    title: c.title,
    content: c.iconEl || c.label,
    active: c.active,
  }));

  const selectedOption = options.find((o) => o.id === toggleButton?.selected) || options[0];

  if (!toggleButton) return null;

  if (toggleButton.variant === 'single') {
    return (
      <ToggleButton
        variant="single"
        onChange={(option) => {
          const newSelectedOption = options.find((o) => o.id !== option.id) as ToggleButtonOption<string>;

          const selectedCommand = commands.find((c) => c.id === newSelectedOption.id) as EnhancedCommand;
          if (onClick) onClick(selectedCommand);
        }}
        options={options}
        selectedOption={selectedOption}
        disabled={!active}
      />
    );
  }

  return (
    <ToggleButton
      variant={toggleButton.variant}
      onChange={(option) => {
        const selectedCommand = commands.find((c) => c.id === option.id) as EnhancedCommand;
        if (onClick) onClick(selectedCommand);
      }}
      options={options}
      selectedOption={selectedOption}
      disabled={!active}
    />
  );
}

export default CommandToggleButton;
